import React, { useContext } from 'react';
import { ThemeContext } from '../context/ThemeContext';
import { Button } from './ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';
import { cn } from '../lib/utils';

const THEMES = [
  { value: 'light', label: 'Light', swatch: 'bg-amber-400' },
  { value: 'dark', label: 'Dark', swatch: 'bg-sky-400' },
  { value: 'dawn', label: 'Dawn', swatch: 'bg-rose-400' },
];

const ThemeSwitcher = () => {
  const { toggleTheme, themeName } = useContext(ThemeContext);

  const activeTheme = THEMES.find((theme) => theme.value === themeName) || THEMES[0];

  return (
    <div className="fixed right-6 top-6 z-40">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            variant="outline"
            className="gap-2 rounded-full border-border/60 bg-card/70 text-xs uppercase tracking-[0.22em] text-foreground shadow-lg backdrop-blur-xl hover:bg-card"
          >
            <span className={cn('h-2.5 w-2.5 rounded-full', activeTheme.swatch)} />
            <span>{activeTheme.label}</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-40">
          {THEMES.map((theme) => (
            <DropdownMenuItem
              key={theme.value}
              onSelect={() => toggleTheme(theme.value)}
              className={cn(
                theme.value === themeName && 'bg-accent text-accent-foreground'
              )}
            >
              <span className={cn('h-2.5 w-2.5 rounded-full', theme.swatch)} />
              <span className="ml-2">{theme.label}</span>
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};

export default ThemeSwitcher;
